export default {
  loginOrRegister: {
    registration: 'Registration (30 sec)',
    login: 'Login',
    authentication: 'Authentication'
  }
}
